import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { ApiService, requiredFileType, markAllAsDirty, toFormData, requiredFileSize } from 'src/app/_services/api.service';

@Component({
    selector: 'app-websiteSupport',
    templateUrl: './websiteSupport.component.html',
    styleUrls: ['./websiteSupport.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebsiteSupportComponent implements OnInit {

  progress = 0;
  contactForm: any;
  success = false;

  // eserviceChoices: any;

  eserviceOptions = [
    { id: 'changeMailingAddress', value: 'Change of Mailing Address Form e-File', label: 'Change of Mailing Address Form e-File' },
    { id: 'homeownerExemption',  value: 'Homeowners\' Exemption Form e-File', label: "Homeowners' Exemption Form e-File" },
    { id: 'pdcr',                value: 'Property Data Change Request e-File', label: 'Property Data Change Request e-File' },
    { id: 'alertService',        value: 'Homeowner Alert Service (e-Notification)', label: 'Homeowner Alert Service (e-Notification)' }
  ];
  // value: any;


  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService ) {
    this.contactForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      ains: this.formBuilder.array([
        this.createAinControl()   // start with one empty AIN
      ]),
      // number: '',
      // direction: '',
      // street: ['', Validators.required],
      // type: '',
      // unit: '',
      // city: ['', Validators.required],
      // zipCode: ['', Validators.required],
      topic: ['', Validators.required],
      eserviceChoices: this.formBuilder.array(
        this.eserviceOptions.map(() => this.formBuilder.control(false))
      ),
      eserviceValues: this.formBuilder.array([]),
      description: '',
      email: ['', Validators.required],
      file: ['', [requiredFileType(''), requiredFileSize(10000000)]],
      // eserviceChoice: ['', Validators.required],
      recaptchaReactive: ['', Validators.required]
    });
  }

  //code to enable multiple ain inputs
  get ains(): FormArray {
    return this.contactForm.get('ains') as FormArray;
  }

  private createAinControl(): FormControl {
    return this.formBuilder.control('', []);
  }

  addAin(): void {
    this.ains.push(this.createAinControl());
  }

  removeAin(index: number): void {
    this.ains.removeAt(index);
  }

  //code to update eservice values

  get eserviceChoices(): FormArray {
    return this.contactForm.get('eserviceChoices') as FormArray;
  }

  getSelectedEserviceValues(): string[] {
    const choices = this.eserviceChoices.value as boolean[];
    return this.eserviceOptions
      .filter((_, index) => choices[index])
      .map(opt => opt.value);
  }

  onCheckboxChange(index: number) {
    const selected = this.getSelectedEserviceValues();
    const valuesArray = this.contactForm.get('eserviceValues') as FormArray;

    valuesArray.clear();
    selected.forEach(v => valuesArray.push(new FormControl(v)));
  }

  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }
    toFormData(this.contactForm.value)
    console.log(this.contactForm)

    this.apiService.sendForm(toFormData(this.contactForm.value), 'websitesupport').subscribe(res => {
      console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

  requireAtLeastOneCheckbox() {
    return (formArray: FormArray) => {
      const atLeastOneSelected = formArray.controls.some(ctrl => ctrl.value);
      return atLeastOneSelected ? null : { required: true };
    };
  }



  ngOnInit() {
    this.contactForm.get('topic')?.valueChanges.subscribe(topicValue => {
    const eserviceArray = this.contactForm.get('eserviceChoices') as FormArray;

    if (topicValue === 'e-Services') {
      // Require at least one selection
      eserviceArray.setValidators([this.requireAtLeastOneCheckbox()]);
    } else {
      eserviceArray.clearValidators();
    }

      eserviceArray.updateValueAndValidity();
    });
  }

}
